import {
  BaseQueryFn,
  createApi,
  fetchBaseQuery,
  retry,
} from '@reduxjs/toolkit/query/react';
import { IInternalAccount } from 'src/api/internal/internalApi.types';
import { API_MAX_RETRY_COUNT, createBaseUrl, setHeaders } from '..';
import { RootState } from '../../state/store';

/**
 * Base query configuration for atv API calls.
 * @param args
 * @param api
 * @param extraOptions
 * @returns
 */
const internalBaseQuery: BaseQueryFn = async (args, api, extraOptions) => {
  const { appConfig } = api.getState() as RootState;
  const result = await fetchBaseQuery({
    baseUrl: createBaseUrl(appConfig, appConfig.apiBasePath),
    prepareHeaders: (headers, { getState }) => {
      return setHeaders(headers, (getState() as RootState).appConfig.apiKey);
    },
    credentials: 'include',
  })(args, api, extraOptions);
  return {
    ...result,
  };
};

const baseQueryWithRetry = retry(internalBaseQuery);
export const internalApi = createApi({
  reducerPath: 'internalApi',
  baseQuery: baseQueryWithRetry,
  endpoints: (builder) => ({
    getInternalAccounts: builder.query<IInternalAccount[], void>({
      query: () => `internal/accounts`,
      extraOptions: { maxRetries: API_MAX_RETRY_COUNT },
    }),
  }),
});

export const { useGetInternalAccountsQuery } = internalApi;
